import { HeaderStyles } from "./Header.styles";
import { HeaderProps } from './Header';
import { Logo, CustomIcon } from 'ams-ui-reactkit';
import clsx from 'clsx';
import { navigate } from "@reach/router";
import { LinearProgress, Typography } from "@material-ui/core";
import { StoreContext } from '../../context';
import { useContextSelector } from '@fluentui/react-context-selector';

const HeaderView = ({ logoSrc, logoClick, progressValue, profile, help, helpClick, backNav }: HeaderProps) => {
	const classes = HeaderStyles();
	const appState: any = useContextSelector(StoreContext, store => store?.appState);
	const handleCall = () => {
		const OfficePhone = appState?.customerInfo?.OfficePhone
		// console.log("OfficePhone:", OfficePhone);
		//window.open(`tel:${OfficePhone}`);
		window.location.href = `tel:${OfficePhone}`;
	}
	return (
		<div className={classes.headContainer}>
			<div className={classes.headContainerinr}>
				<div className={clsx(classes.headDivider, "d-flex mn-width-40 a-items-center")}>
					{backNav ? <span onClick={() => navigate(-1)}><CustomIcon iconName="ArrowBack" /></span> : null}
				</div>
				<div className={classes.headDivider}>
					<span onClick={() => {
						console.log(appState, ">>>>>")
						navigate("/");
					}} className={classes.driverLogo}>
						<div style={{margin:8	}}>
						<img style={{ maxWidth:250, maxHeight:56}} src={logoSrc}/>
						</div>
				
						{/* <Logo /> */}
					</span>
				</div>
				<div className={clsx(classes.headDivider, classes.callInformation, "mn-width-40 callInfoCTA")}>
					<a className="" onClick={handleCall}>
						<div>
							<CustomIcon iconName="call" />
						</div>
						<div>
							<Typography variant="subtitle2" component="span" className="spanTitle">CALL US</Typography>
						</div></a>
				</div>
			</div>
			{progressValue ? <LinearProgress
				variant="determinate"
				value={progressValue || 0}
				color="primary"
				classes={{
					root: classes.linearProgressMain,
					barColorPrimary: classes.linearProgressPrimary,
					determinate: classes.linearProgressDeterminate,
					bar1Determinate: classes.linearProgressbar1Determinate,
				}}
			/> : null}
		</div>
	);
}

export default HeaderView